<template>
  <div class="testinmony" style="min-height:300px;">
    <button
      id="testimonyButton"
      class="button-icon"
      v-on:click="toggleClick"
    >Click here to submit a Testimony
    </button>
    <div v-if="testClick" class="card-body">
      <form @submit.prevent="checkToken">
        <div class="form-group">
          <label>Name:</label>
          <input
            required
            type="text"
            class="form-control names"
            v-model="newtestimony.name"
          />
          <label>Location:</label>
          <input
            required
            type="text"
            class="form-control names"
            v-model="newtestimony.location"
          />
          <label>Description:</label>
          <textarea
            wrap="hard"
            style="resize: none;"
            placeholder="Add description here"
            class="form-control names descritpion"
            v-model="newtestimony.description"
          >
          </textarea>
          <label class="uploadbutton form-control">
            <input
              type="file"
              id="file"
              ref="myFiles"
              accept="image/*"
            >Click here to Upload Image
          </label>
          <label>Add Token:
          <input
            style="width: 180px;"
            required
            type="text"
            class="form-control names"
            v-model="token"
          /></label>
      </div>
      <div class="form-group">
        <input
          type="submit"
          class="btn-submit"
          value="Submit"
        />
      </div>
      </form>
    </div>
  <!--  -->
    <div v-for="info in pageOfItems" v-bind:key="info.id">
      <div class="borderlayout">
        <div class="profileimage">
          <img class="imagesize" :src="info.imageURL" />
        </div>
        <div class="infolayout">
          <p id='name' class="titleinfo"><b>Name: </b>{{ info.name }}</p>
          <p id='location' class="titleinfo"><b>Location: </b>{{ info.location }}</p>
          <p id='description' class="titleinfo"><b>Description: </b>{{ info.description }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <jw-pagination :items="testimony" @changePage="onChangePage"></jw-pagination>
    </div>
  </div>
</template>

<script>
import db from '../../config/db'
import Swal from 'sweetalert2'

export default {
  name: 'testimony',
  data () {
    return {
      testimony: [],
      testClick: false,
      newtestimony: {
        name: '',
        location: '',
        description: '',
        imagename: ''
      },
      token: '',
      files: '',
      pageOfItems: []
    }
  },
  mounted () {
    this.getDB()
    this.$store.commit('checkENV')
  },
  methods: {
    toggleClick () {
      if (this.testClick === false) {
        this.testClick = true
      } else if (this.testClick === true) {
        this.testClick = false
      }
    },
    checkToken () {
      const vm = this
      db.firestore
        .collection('token' + this.$store.state.env)
        .doc('access')
        .get()
        .then(function (doc) {
          if (vm.token === doc.data().token) {
            vm.addDB()
            vm.storeFiles()
            vm.notication('Success', 'success')
            vm.testClick = false
            vm.newtestimony = {}
            vm.token = ''
          } else {
            vm.notication('Invalid Token', 'error')
          }
        })
    },
    addDB () {
      const vm = this
      if (this.$refs.myFiles.files.length === 1) {
        this.newtestimony.imagename = this.$refs.myFiles.files[0].name
      } else {
        this.newtestimony.imagename = 'no-image.png'
      }
      db.firestore.collection('/testimony' + this.$store.state.env).add({
        name: this.newtestimony.name,
        location: this.newtestimony.location,
        Description: this.newtestimony.description,
        imageName: this.newtestimony.imagename,
        timestamp: new Date()
      }).then(setTimeout(() => { vm.getDB() }, 2000))
    },
    storeFiles () {
      if (this.newtestimony.imagename !== 'no-image.png') {
        const fileInfo = this.$refs.myFiles.files[0]
        db.storing.ref(
          'images' + this.$store.state.env + '/' +
          fileInfo.name
        ).put(fileInfo)
      }
    },
    getDB () {
      const vm = this
      let testimonyinfo = []
      let data = {}
      db.firestore.collection('testimony' + this.$store.state.env)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // Using image name to obtain image url
            db.storing.ref('images' + this.$store.state.env + '/')
              .child(doc.data().imageName)
              .getDownloadURL()
              .then((downloadURL) => {
                data = {
                  id: doc.id,
                  name: doc.data().name,
                  location: doc.data().location,
                  description: doc.data().Description,
                  imageURL: downloadURL,
                  timestamp: doc.data().timestamp
                }
                testimonyinfo.push(data)
                testimonyinfo = testimonyinfo.sort(
                  (a, b) => b.timestamp - a.timestamp
                )
              })
          })
        })
      vm.testimony = testimonyinfo
    },
    notication (text, icon) {
      Swal.fire({
        title: text,
        icon: icon,
        timer: 1500,
        showConfirmButton: false
      })
    },
    onChangePage (pageOfItems) {
      this.pageOfItems = pageOfItems
      // window.scrollTo(0, 150)
    }
  }
}

</script>

<style lang="scss">
@import "../assets/common.scss";

.borderlayout {
  display: flex;
  flex-direction: row;
  margin : 0 auto;
  min-height: 160px;
  // max-height: 240px;
  width: 60%;
  box-sizing: border-box;
  border: .1px solid $content-colour;
  margin-bottom: 5px;
  margin-top: 5px;

  @media (max-width: 760px) {
    flex-direction: column;
    width: 95%;
    min-height: 300px;
    // max-height: 480px;
    font-size: 1rem;
  }

  .profileimage {
    height: 100%;
    width: 25%;

    @media (max-width: 760px) {
      width: 100%;
      margin: 0 auto;
    }

    .imagesize {
      min-height: 160px;
      max-height: 238px;
      min-width: 35%;
      max-width: 100%;
    }
  }

  .infolayout {
    width: 75%;
    box-sizing: border-box;
    border-left: .1px solid $content-colour;

    @media (max-width: 760px) {
      width: 100%;
      border-top: .1px solid $content-colour;
      border-left: none;
    }
  }

  .titleinfo {
    text-align: left;
    margin-left: 10px;
    margin-right: 10px;
    overflow-wrap: break-word;
    hyphens: auto;

    @media (max-width: 760px) {
      font-size: .8rem;
      margin: auto 5px 2px 5px;
    }
  }
}

label.uploadbutton {
  display: flex;
  flex-direction: column-reverse;
  padding-right: 15px;
  color: $media-colour;
  font-size: 1.5rem;
  text-decoration:none;
  cursor: pointer;
  margin-bottom: 5px;

  @media (max-width: 760px) {
    font-size: 1rem;
  }

  input {
    width: 300px;
    margin : 0 auto;
  }
}

.button-icon {
  background-color: $media-colour;
  font-size: 1.5rem;
  text-decoration:none;
  border: none;
  color: $inactive-colour;
  padding: 10px 20px;
  text-align: center;
  display: inline-block;
  margin: 4px 2px;
  border-radius: 16px;
  width: 30%;

  @media (max-width: 760px) {
    font-size: 1rem;
    width: 70%;
  }

  a {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: bold;
    text-decoration:none;
    color: $inactive-colour;
  }
}

.card-body {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.09);
  border-radius: 3px;
  margin: 20px auto 20px auto;
  background-color: white;
  width: 60%;
  height: 325px;
  padding: 10px 0;

  @media (max-width: 760px) {
    height: 310px;
    width: 95%;
    margin-left: 5px;
  }
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.btn-submit {
  width: 20%;
  height: 30px;
  margin : 0 auto;
  display: block;
  background-color: $active-colour;
  color: white;
  border-radius: 16px;

  @media (max-width: 760px) {
    width: 60%;
  }
}
.btn-submit:hover {
  background-color: #b5c9c9;
}
.names {
  margin: auto;
  margin-bottom: 5px;
  width: 300px;

  @media (max-width: 760px) {
    width: 90%;
  }
}

.descritpion {
  height: 80px !important;
  width: 800px;
  overflow-wrap: break-word;
  hyphens: auto;

  @media (max-width: 760px) {
    width: 90%;
  }
}
</style>
